import FloatingVue from 'floating-vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from '@/js/account/app/App.vue';
import { installErrorReporting } from '@/js/account/app/error-reporting';
import { router } from '@/js/account/app/router';
import { setupRouterGuards } from '@/js/account/app/router/guards';
import { trackEmailVerifiedOnce } from '@/js/lib/analytics';
import 'floating-vue/dist/style.css';
import '@/scss/account.scss';

const mountEl = document.getElementById('account-app');

if (!mountEl) {
  throw new Error('Account SPA mount element #account-app not found');
}

// Before the router runs: its redirects drop the ?verified=1 flag set by the server.
trackEmailVerifiedOnce();

const app = createApp(App);

installErrorReporting(app);

app.use(createPinia());
app.use(FloatingVue, {
  themes: {
    popover: {
      $extend: 'dropdown',
      distance: 8,
    },
  },
});
app.use(router);
setupRouterGuards(router);

app.mount(mountEl);
